export { default as BrandViewBrandCover } from "./BrandViewBrandCover";
